/**
 * Needs to be loaded at top
 * Lodash alternatives helper function enqueue
 * Custom script to load before gwp-child-theme 
 */
var jh_custom = {};
( function($) { 

    // Vanilla Debounce
    var _debounce = function(func, wait) {
        var timeout;

        return function executedFunction(args) {
            var later = function () {
                clearTimeout(timeout);
                func(args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }; 
    jh_custom.debounce = _debounce;
    
})( jQuery );

/*
 JS Objects Helper

 Objects that are nested are a pain to deal with.

 var localized = {
    preferences: {
        errors: [
            {
                error: 'This is a submission error!'
            }
        ]
    }
 }

 Huge Hassle:
    localized.preferences &&
    localized.preferences.errors &&
    localized.preferences.errors[0] &&
    localized.preferences.errors[0].error

 Check By:
    deepObject(localized, 'preferences.errors.0.error')

 */
(function (window, document, $) {
    'use strict';

    window.deepObject = function(source, path) {

        if ( typeof path !== 'string' ) {
            return undefined;
        }

        path = path.split('.')
        var obj = source[ path.shift() ]

        while( obj && path.length ) {
            obj= obj[ path.shift() ]
        }

        return obj;
    };

})( window, document, jQuery );
